import { useQuery } from "@tanstack/react-query";

export function useGetDatasetOfferDetails({ callApiWithWorker, offerId }) {
  return useQuery({
    queryKey: ["datasetOffers", offerId],
    enabled: !!offerId,
    queryFn: async ({ signal }) => {
      const res = await callApiWithWorker(`/dataset-offers/${offerId}`, {
        method: "GET",
        signal,
      });

      const body =
        typeof res?.body === "string"
          ? JSON.parse(res.body)
          : (res?.data ?? res);
      return body;
    },
  });
}
